<template>
  <div>
    <div v-for="(con, i) in messageList" :key="i">
      <!-- is Text From Me -->
      <div
        v-if="con.senderId == meProfile.chatId"
        class="d-flex justify-content-end mb-4"
      >
        <div v-if="con.isDummy" class="my-auto pr-2 pl-3">
          <div class="spinner-grow text-secondary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div
          :class="[
            con.messageResponse.content.responseType == 6
              ? 'msg_cotainer_send_img'
              : 'msg_cotainer_send',
          ]"
        >
          <div v-if="con.messageResponse.content.responseType == 6">
            <!-- v-if="
                con.isDummy && con.messageResponse.content.responseType == 6
              " -->
            <!-- <div class="my-auto pr-2 loading-dummy-img">
              <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div> -->
            <div
              v-for="(item, i) in con.messageResponse.content.imageList"
              :key="i"
              class="img_upload"
            >
              <div
                class="img_upload-display"
                v-bind:style="{
                  backgroundImage: 'url(' + item.imageUrl + ')',
                }"
              ></div>
            </div>
          </div>
          <span class="msg_wrap" v-else>{{
            con.messageResponse.content.content.text
          }}</span>
          <span class="msg_time_send text-nowrap">
            <ChatDateTime :date="con.createdTime" />
          </span>
        </div>
        <div class="img_cont_msg">
          <div
            v-if="meProfile.photoUrl && meProfile.photoUrl.trim()"
            class="rounded-circle user_img_msg"
          >
            <div
              class="rounded-circle user_img_display"
              v-bind:style="{
                backgroundImage: 'url(' + meProfile.photoUrl + ')',
              }"
            ></div>
          </div>
          <font-awesome-icon
            v-else
            :icon="['fas', 'user']"
            class="rounded-circle user_img_msg p-1"
          />
        </div>
      </div>
      <!-- is Text From Other -->
      <div v-else class="d-flex justify-content-start mb-4">
        <div class="img_cont_msg">
          <div
            v-if="otherInfo.photoUrl && otherInfo.photoUrl.trim()"
            class="rounded-circle user_img_msg"
          >
            <div
              class="rounded-circle user_img_display"
              v-bind:style="{
                backgroundImage: 'url(' + otherInfo.photoUrl + ')',
              }"
            ></div>
          </div>
          <font-awesome-icon
            v-else
            :icon="['fas', 'user']"
            class="rounded-circle user_img_msg p-1"
          />
        </div>
        <div
          :class="[
            con.messageResponse.content.responseType == 6
              ? 'msg_cotainer_img'
              : 'msg_cotainer',
          ]"
        >
          <div v-if="con.messageResponse.content.responseType == 6">
            <div
              v-for="(item, i) in con.messageResponse.content.imageList"
              :key="i"
              class="img_upload"
            >
              <div
                class="img_upload-display"
                v-bind:style="{
                  backgroundImage: 'url(' + item.imageUrl + ')',
                }"
              ></div>
            </div>
          </div>
          <span class="msg_wrap" v-else>{{
            con.messageResponse.content.content.text
          }}</span>
          <span class="msg_time text-nowrap">
            <ChatDateTime :date="con.createdTime" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatDateTime from "@/components/chat/ChatDateTime";
export default {
  name: "ChatBoxMessageList",
  components: {
    ChatDateTime,
  },
  props: {
    messageList: {
      required: true,
      type: Array,
    },
    meProfile: {
      required: true,
      type: Object,
    },
    otherInfo: {
      required: true,
      type: Object,
    },
  },
  methods: {},
  data() {
    return {};
  },
  created: async function() {},
};
</script>

<style lang="scss" scoped>
.msg_cotainer_send_img {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: auto;
  padding: 2px 10px;
  position: relative;
  display: flex;
  justify-content: flex-end;
  width: 80%;
}
.msg_cotainer_send_img div {
  display: flex;
  width: 100%;
}
.msg_cotainer_send_img div .img_upload {
  margin-left: auto;
  height: auto;
  max-height: 20rem;
  width: 100%;
  max-width: 30rem;
}
.msg_cotainer_send_img div .img_upload .img_upload-display {
  width: 100%;
  padding-bottom: 56.25%;
  background-size: contain;
  background-position: top right;
  background-repeat: no-repeat;
  background-color: #fff;
}
.msg_cotainer_send {
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 10px;
  border-radius: 4px;
  background-color: #f3591f;
  color: #fff;
  padding: 10px;
  position: relative;
  max-width: 82%;
  min-width: 25%;
  font-size: 14px;
}
.spinner-grow {
  width: 20px;
  height: 20px;
}
.msg_wrap {
  white-space: pre-line;
  overflow-wrap: break-word;
}
.msg_time_send {
  position: absolute;
  right: 0;
  bottom: -15px;
  color: #dbdbdb;
  font-size: 10px;
}
.msg_cotainer_send_img .msg_time_send {
  padding-right: 10px;
}
.user_img_msg {
  height: 40px;
  width: 40px;
  border: 1.5px solid #f5f6fa;
}
.user_img_display {
  width: 100%;
  padding-bottom: 100.5%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #fff;
}
.msg_cotainer_img {
  margin-top: auto;
  margin-bottom: auto;
  // margin-left: auto;
  padding: 2px 10px;
  position: relative;
  display: flex;
  justify-content: flex-start;
  width: 80%;
}
.msg_cotainer_img div {
  display: flex;
  width: 100%;
}
.msg_cotainer_img div .img_upload {
  margin-right: auto;
  height: auto;
  max-height: 20rem;
  width: 100%;
  max-width: 30rem;
}
.msg_cotainer_img div .img_upload .img_upload-display {
  width: 100%;
  padding-bottom: 56.25%;
  background-size: contain;
  background-position: top left;
  background-repeat: no-repeat;
  background-color: #fff;
}
.img_cont_msg {
  height: 40px;
  width: 40px;
}
.msg_cotainer {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 10px;
  border-radius: 4px;
  background-color: #dbdbdb;
  padding: 10px;
  position: relative;
  max-width: 82%;
  min-width: 25%;
  font-size: 14px;
}
.msg_time {
  position: absolute;
  left: 0;
  bottom: -15px;
  color: #dbdbdb;
  font-size: 10px;
}
.msg_cotainer_img .msg_time {
  padding-left: 10px;
}
.loading-dummy-img {
  position: absolute;
  width: 20%;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
}
@media (max-width: 767.98px) {
}
</style>
